import React from "react";

const AbsoluteSkewebar = ({ text, isBgRed }) => {
  return (
    <div className="w-full relative">
      <img
        src={
          isBgRed
            ? "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709289658.svg"
            : "https://elchemy-website.s3.ap-south-1.amazonaws.com/products/icons/1709289729.svg"
        }
        width={64}
        className="absolute top-1 md:top-[-0.8rem] h-6 sm:h-14 md:h-16 left-[-2.7rem] md:left-[-4rem]"
      />
      <h2
        className={`text-[1.5rem] md:text-[2.5rem] font-mukta font-light ${
          isBgRed ? "text-white" : "text-[#161616]"
        }`}
      >
        {text}
      </h2>
    </div>
  );
};

export default AbsoluteSkewebar;
